import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaAdministradoresAtivos = () => {
    const [listaAdministradoresAtivos, setListaAdministradoresAtivos] = useState([])

    const buscaAdministradoresAtivos = useCallback(() => {
        http.get(`/administradores-ativos`)
            .then(res => {
                const resposta = res.data
                setListaAdministradoresAtivos(resposta)
            })
            .catch(() => setListaAdministradoresAtivos([]))
    }, [])

    useEffect(() => {
        buscaAdministradoresAtivos()
    }, [buscaAdministradoresAtivos])

    useRecarregaAoRenovarToken(buscaAdministradoresAtivos)

    return {
        listaAdministradoresAtivos,
    }
}
